import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import type { PipelineStage } from '../models/job';
import { stageDisplayLabel, stageTypeDisplayLabel } from '../utils/pipeline-stages';

type StageLabelSource = Pick<
  PipelineStage,
  'label' | 'isDefault' | 'stageType' | 'isLabelCustomized'
>;

/** Locale-aware stage name resolver; re-renders on language change. */
export function useStageDisplayLabel(): (stage: StageLabelSource) => string {
  const { t } = useTranslation('job');
  return useCallback((stage: StageLabelSource) => stageDisplayLabel(stage, t), [t]);
}

/** Same rule keyed by stage type, for aggregate views (stats tiles, chart legends). */
export function useStageTypeDisplayLabel(
  stages: PipelineStage[] | undefined
): (stageType: string) => string {
  const { t } = useTranslation('job');
  return useCallback(
    (stageType: string) => stageTypeDisplayLabel(stages, stageType, t),
    [stages, t]
  );
}
